import React, { useState } from 'react'
import { Card, Row, Col, Badge } from 'react-bootstrap'

export const IndicadoresOt = (equipos) => {
if(equipos){
        // Inicializamos contadores para cada estado
        let contadorNoFinalizado = 0;
        let contadorFinalizado = 0;
        let contadorPendiente = 0;
        let contadorCancelado = 0;
        let contadorProcesado = 0;
        let contadorAprobado = 0;
        // Nuevo estado (spec lotes-estado-en-proceso-mediciones-condicionales).
        let contadorEnProceso = 0;
        let totalEquipos = equipos.length;

        // Iteramos sobre cada equipo
        equipos.forEach((equipo) => {
            // Incrementamos el contador correspondiente al estado del equipo
            switch (equipo.estado) {
                case "Aprobado":
                    contadorAprobado++;
                    break;
                case "Pendiente":
                    contadorPendiente++;
                    break;
                case "Finalizado":
                    contadorFinalizado++;
                    break;
                case "No Finalizado":
                    contadorNoFinalizado++;
                    break;
                case "Cancelado":
                    contadorCancelado++;
                    break;
                case "Procesado":
                    contadorProcesado++;
                    break;
                case "En Proceso":
                    contadorEnProceso++;
                    break;
                default:
                    break;
            }
        });

        // Calculamos los porcentajes para cada estado
        const porcentajeNoFinalizado = Math.round((contadorNoFinalizado / totalEquipos) * 100);
        const porcentajeFinalizado = Math.round((contadorFinalizado / totalEquipos) * 100);
        const porcentajePendiente = Math.round((contadorPendiente / totalEquipos) * 100);
        const porcentajeCancelado = Math.round((contadorCancelado / totalEquipos) * 100);
        const porcentajeProcesado = Math.round((contadorProcesado / totalEquipos) * 100);
        const porcentajeAprobado = Math.round((contadorAprobado / totalEquipos) * 100);
        const porcentajeEnProceso = Math.round((contadorEnProceso / totalEquipos) * 100);

        // Creamos el objeto de indicador con los porcentajes
        const indicador = {
            "No_finalizados": porcentajeNoFinalizado,
            "En_proceso": porcentajeEnProceso,
            "Finalizados": porcentajeFinalizado,
            "Pendientes": porcentajePendiente,
            "Cancelados": porcentajeCancelado,
            "Procesados": porcentajeProcesado,
            "Aprobados": porcentajeAprobado,
        };

        return (indicador)
    }
  }

  
const ESTADOS_NO_CERTIFICADOS = ['Cancelado', 'Pendiente', 'Aplazado', 'No Finalizado']
const ESTADOS_PENDIENTES      = ['Pendiente', 'Aplazado']
const ESTADOS_CANCELADOS      = ['Cancelado']
const ESTADOS_CERTIFICADOS    = ['Procesado', 'Finalizado', 'Aprobado', 'Entregado']

export const ContadoresOt = ({ots}) => {
    const [visible, setVisible] = useState(true);

    let itemsList    = []
    let pendientes   = []
    let cancelados   = []
    let certificados = []

    if (ots?.equipos) {
        itemsList    = contarEquipos(ots.equipos)
        pendientes   = ots.equipos.filter(e => ESTADOS_PENDIENTES.includes(e.estado))
        cancelados   = ots.equipos.filter(e => ESTADOS_CANCELADOS.includes(e.estado))
        certificados = ots.equipos.filter(e => ESTADOS_CERTIFICADOS.includes(e.estado))
    }

    return (
      <div className="container-fluid w-100">
        <Card className="shadow-sm w-100 mb-2 p-0">
          <Card.Header
            className="bg-dark text-white w-100 d-flex justify-content-between align-items-center"
            style={{ cursor: 'pointer' }}
            onClick={() => setVisible(v => !v)}
          >
            <strong><i className="bi bi-bar-chart-fill me-2"></i>Indicadores de avance</strong>
            <i className={`bi bi-chevron-${visible ? 'up' : 'down'}`}></i>
          </Card.Header>

          {visible && (
            <Card.Body className="p-3 w-100">
              <Row className="g-3">
                {/* Card de Resumen Total */}
                <Col xs={12} md={3}>
                  <Card className="shadow-sm border-primary w-100">
                    <Card.Header className="bg-primary text-white w-100"
                      style={{ minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                      <strong>Resumen Total</strong>
                    </Card.Header>
                    <Card.Body className="d-flex flex-column justify-content-between w-100">
                      <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold">Cargados:</span>
                          <Badge bg="primary" className="fs-6">{ots?.equipos?.length || 0}</Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold">
                            <i className="bi bi-hourglass-split text-warning me-1"></i>En espera:
                          </span>
                          <Badge bg="warning" text="dark" className="fs-6">{pendientes.length}</Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold">
                            <i className="bi bi-x-circle-fill text-danger me-1"></i>Cancelados:
                          </span>
                          <Badge bg="danger" className="fs-6">{cancelados.length}</Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-bold">
                            <i className="bi bi-patch-check-fill text-success me-1"></i>Certificados:
                          </span>
                          <Badge bg="success" className="fs-6">{certificados.length}</Badge>
                        </div>
                      </div>
                      <hr />
                      <div className="text-center text-muted small">
                        <i className="bi bi-tools me-1"></i>
                        {ots?.equipos?.length || 0} equipos totales
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Cards de Ítems */}
                <Col xs={12} md={9}>
                  <Card className="shadow-sm w-100">
                    <Card.Header className="bg-secondary text-white w-100">
                      <strong>Ítems por Tipo ({itemsList?.length || 0})</strong>
                    </Card.Header>
                    <Card.Body className="w-100">
                      <Row className="g-2">
                        {itemsList && itemsList.map((item, index) => (
                          <Col xs={6} sm={4} md={3} lg={2} key={index}>
                            <Card className="border-primary shadow-sm w-100">
                              <Card.Header
                                className="bg-primary text-white p-2 text-center w-100"
                                style={{ minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                              >
                                <small className="fw-bold" style={{ fontSize: '0.85rem', wordWrap: 'break-word' }}>
                                  {item?.nombre}
                                </small>
                              </Card.Header>
                              <Card.Body className="p-2 w-100">
                                <div className="d-flex justify-content-around align-items-center">
                                  <div className="text-center">
                                    <small className="text-muted d-block mb-1">Total</small>
                                    <Badge bg="info">{item?.total || 0}</Badge>
                                  </div>
                                  <div className="text-center">
                                    <small className="text-muted d-block mb-1">
                                      <i className="bi bi-hourglass-split text-warning"></i>
                                    </small>
                                    <Badge bg="warning" text="dark">{item?.pendientes || 0}</Badge>
                                  </div>
                                  <div className="text-center">
                                    <small className="text-muted d-block mb-1">
                                      <i className="bi bi-x-circle-fill text-danger"></i>
                                    </small>
                                    <Badge bg="danger">{item?.cancelados || 0}</Badge>
                                  </div>
                                  <div className="text-center">
                                    <small className="text-muted d-block mb-1">
                                      <i className="bi bi-check-circle-fill text-success"></i>
                                    </small>
                                    <Badge bg="success">{item?.certificados || 0}</Badge>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}

                        {(!itemsList || itemsList.length === 0) && (
                          <Col xs={12}>
                            <div className="text-center text-muted py-4">
                              <i className="bi bi-inbox fs-1 d-block mb-2"></i>
                              <p>No hay ítems para mostrar</p>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          )}
        </Card>
      </div>
    )
}

  export function contarEquipos(equipos){
    const resultadosArray = [];

    const findIndexByName = (array, name) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i].nombre === name) return i;
        }
        return -1;
    };

    equipos.forEach(equipo => {
        const nombreEquipo = equipo.snapshot.item;
        const estado       = equipo.estado;

        const index = findIndexByName(resultadosArray, nombreEquipo);

        if (index === -1) {
            resultadosArray.push({
                nombre:       nombreEquipo,
                total:        1,
                pendientes:   ESTADOS_PENDIENTES.includes(estado)   ? 1 : 0,
                cancelados:   ESTADOS_CANCELADOS.includes(estado)   ? 1 : 0,
                certificados: ESTADOS_CERTIFICADOS.includes(estado) ? 1 : 0,
                responsables: {}
            });
        } else {
            resultadosArray[index].total++;
            if (ESTADOS_PENDIENTES.includes(estado))   resultadosArray[index].pendientes++;
            if (ESTADOS_CANCELADOS.includes(estado))   resultadosArray[index].cancelados++;
            if (ESTADOS_CERTIFICADOS.includes(estado)) resultadosArray[index].certificados++;
        }

        const resultIndex = findIndexByName(resultadosArray, nombreEquipo);
        if (resultIndex !== -1) {
            const responsable = equipo.responsable
                ? equipo.responsable.nombre + ' ' + equipo.responsable.apellido
                : '';
            if (!resultadosArray[resultIndex].responsables[responsable]) {
                resultadosArray[resultIndex].responsables[responsable] = 0;
            }
            resultadosArray[resultIndex].responsables[responsable]++;
        }
    });

    resultadosArray.sort((a, b) => a.nombre.length - b.nombre.length);
    return resultadosArray;
}
  
  


